export default {
      id: "icon-plus-card-usage",
      viewBox: "0 0 18 17",
      url: "../icon/" + "icons.svg#icon-plus-card-usage",
      toString: function () {
        return this.url;
      }
    }